import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { DeleteConfirmationData } from '../../models/modal-data.model';

@Component({
  selector: 'app-delete-confirmation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.scss'],
})
export class DeleteConfirmationComponent implements OnInit {
  public title: string = '';
  public message: string = '';
  public confirmText: string = 'Löschen';
  public cancelText: string = 'Abbrechen';


  constructor(
    @Inject('MODAL_DATA') private data: DeleteConfirmationData,
    @Inject('MODAL_CLOSE') private modalClose: (result: boolean) => void
  ) { }

  ngOnInit(): void {
    this.title = this.data.title;
    this.message = this.data.message;
    this.confirmText = this.data.confirmText || 'Löschen';
    this.cancelText = this.data.cancelText || 'Abbrechen';
  }

  public confirm(): void {
    this.modalClose(true);
  }

  public close(): void {
    this.modalClose(false);
  }
}
